/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import FileUploadDialog from "./fileUploadDialog";
import { StyledButton } from "../../pages/home/styles";

const FileUploadButton = ({ onUpload, open, setOpen, loading, setLoading, uploadPermission }) => {
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <StyledButton onClick={handleClickOpen} disabled={!uploadPermission}>Upload</StyledButton>
      <FileUploadDialog
        open={open}
        loading={loading}
        setLoading={setLoading}
        onClose={handleClose}
        onUpload={onUpload}
      />
    </div>
  );
};

export default FileUploadButton;
